import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_SBA_LABEL,
  EVENTS_AWARDS_SBA_PATH,
} from "@events-awards/utils/constants";
import {
  AwardType,
  EventsAwardsHomePageContextData,
} from "@events-awards/utils/types";
import SBANominationsDescription from "@sba/components/HomePageNominationsDescription";
import JudgingPanel from "@sba/components/JudgingPanel";
import OrganiserDetails from "@sba/components/OrganiserDetails";
import SBAArticle from "@sba/components/SBAArticle";
import SBADescription from "@sba/components/SBADescription";
import SBAFooter from "@sba/components/SBAFooterComponents/SBAFooter";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * Component to render event and awards page
 */
const EventsAwardsSBAPageContent = ({
  articleProps,
}: EventsAwardsHomePageContextData): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  return (
    <div
      className="w-full"
      data-testid="events-awards-sba-page-content-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish", "abm"]}
        path={EVENTS_AWARDS_SBA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Singapore Business Awards"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title="Singapore Business Awards Latest News & Headlines - THE BUSINESS TIMES"
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_SBA_LABEL} - Find ${EVENTS_AWARDS_SBA_LABEL} News & Headlines, insight and analysis in Singapore, Asia-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_SBA_PATH}
      />

      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.SBA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <SBAArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <SBADescription />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <SBANominationsDescription />
        </Container>
      </div>

      <OrganiserDetails />

      <JudgingPanel />

      <SBAFooter />

      <Ad adType="catfish" />

      <Ad adType="abm" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsSBAPageContent;
